import React from 'react';
import CustomSpinner from 'utils/Spinner/Spinner';
import {usePayWithPocket} from './PayWithPocketProvider';
import CustomInputBox from 'utils/CustomInput/CustomInputBox';

export const PocketTagForm = () => {
    const {pocket_tag, loading, formErrors, handleChange, initializePayment} = usePayWithPocket();

    const handleSubmit = e => {
        e.preventDefault();
        initializePayment();
    };

    return (
        <form className="row" onSubmit={handleSubmit}>
            <div className="col-12 text-center my-4">
                <span className="g-bold text--gray">Enter Pocket Tag to continue</span>
            </div>

            <div className="col-12">
                <CustomInputBox
                    cls="mb-4"
                    error={formErrors?.pocket_tag}
                    label="Pocket Tag"
                    name="pocket_tag"
                    placeholder="Enter Pocket Tag"
                    onChange={({target}) => handleChange(target?.value)}
                    value={pocket_tag}
                />
            </div>

            <div className="col-12 pt-4">
                <button
                    className="btn btn--lg btn--primary g-bold"
                    type="submit"
                    disabled={loading || pocket_tag?.length < 3}
                >
                    {loading ? <CustomSpinner /> : 'Continue'}
                </button>
            </div>
        </form>
    );
};
